module.exports = __webpack_public_path__ + "static/icons/icon-heart-fill-3456a575dcc22e5b421b259b7064b9b2.svg";